import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import { pageMeta } from "@/lib/seo/meta";
import { TOOL_CACHE_HEADERS } from "@/lib/seo/headers";

const EditView = lazy(() => import("@/features/edit/view"));

export const Route = createFileRoute("/edit")({
  head: () =>
    pageMeta({
      title: "Editor",
      description:
        "Open PDFs or images in a workspace. Reorder, rotate, or remove pages, then save as one PDF — all in your browser.",
      path: "/edit",
      keywords: "pdf editor, edit pdf, organize pdf, online, free",
    }),
  headers: () => TOOL_CACHE_HEADERS,
  component: () => (
    <Suspense fallback={null}>
      <EditView />
    </Suspense>
  ),
});
